// App translations (nested JSON, used by phone app and refauth)
import appEnGB from "./app/en-GB.json";
import appEnUS from "./app/en-US.json";
import appFi from "./app/fi.json";
import appTr from "./app/tr.json";
import appCs from "./app/cs.json";
import appSv from "./app/sv.json";
import appIt from "./app/it.json";
import appDa from "./app/da.json";
import appDe from "./app/de.json";
import appEs from "./app/es.json";
import appFr from "./app/fr.json";
import appHe from "./app/he.json";
import appJa from "./app/ja.json";
import appNb from "./app/nb.json";
import appNl from "./app/nl.json";
import appPl from "./app/pl.json";
import appPt from "./app/pt.json";

// Watch translations (flat JSON, used by JS watch app)
import watchEnGB from "./watch/en-GB.json";
import watchEnUS from "./watch/en-US.json";
import watchFi from "./watch/fi.json";
import watchTr from "./watch/tr.json";
import watchCs from "./watch/cs.json";
import watchSv from "./watch/sv.json";
import watchIt from "./watch/it.json";
import watchDa from "./watch/da.json";
import watchDe from "./watch/de.json";
import watchEs from "./watch/es.json";
import watchFr from "./watch/fr.json";
import watchHe from "./watch/he.json";
import watchJa from "./watch/ja.json";
import watchNb from "./watch/nb.json";
import watchNl from "./watch/nl.json";
import watchPl from "./watch/pl.json";
import watchPt from "./watch/pt.json";

// Email translations (used by refauth for email templates)
import emailEnGB from "./email/en-GB.json";
import emailEnUS from "./email/en-US.json";
import emailFi from "./email/fi.json";
import emailTr from "./email/tr.json";
import emailCs from "./email/cs.json";
import emailSv from "./email/sv.json";
import emailIt from "./email/it.json";
import emailDa from "./email/da.json";
import emailDe from "./email/de.json";
import emailEs from "./email/es.json";
import emailFr from "./email/fr.json";
import emailHe from "./email/he.json";
import emailJa from "./email/ja.json";
import emailNb from "./email/nb.json";
import emailNl from "./email/nl.json";
import emailPl from "./email/pl.json";
import emailPt from "./email/pt.json";

export const SUPPORTED_LANGUAGES = [
    "en",
    "en-US",
    "fi",
    "tr",
    "cs",
    "sv",
    "it",
    "da",
    "de",
    "es",
    "fr",
    "ja",
    "nl",
    "nb",
    "pt",
    "he",
    "iw",
    "pl",
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

// App translations
export const appTranslations = {
    enGB: appEnGB,
    enUS: appEnUS,
    fi: appFi,
    tr: appTr,
    cs: appCs,
    sv: appSv,
    it: appIt,
    da: appDa,
    de: appDe,
    es: appEs,
    fr: appFr,
    he: appHe,
    ja: appJa,
    nb: appNb,
    nl: appNl,
    pl: appPl,
    pt: appPt,
};

// Watch translations
export const watchTranslations = {
    enGB: watchEnGB,
    enUS: watchEnUS,
    fi: watchFi,
    tr: watchTr,
    cs: watchCs,
    sv: watchSv,
    it: watchIt,
    da: watchDa,
    de: watchDe,
    es: watchEs,
    fr: watchFr,
    he: watchHe,
    ja: watchJa,
    nb: watchNb,
    nl: watchNl,
    pl: watchPl,
    pt: watchPt,
};

// Email translations
export const emailTranslations = {
    enGB: emailEnGB,
    enUS: emailEnUS,
    fi: emailFi,
    tr: emailTr,
    cs: emailCs,
    sv: emailSv,
    it: emailIt,
    da: emailDa,
    de: emailDe,
    es: emailEs,
    fr: emailFr,
    he: emailHe,
    ja: emailJa,
    nb: emailNb,
    nl: emailNl,
    pl: emailPl,
    pt: emailPt,
};
